/**
 * @file 前端统一接入昊天镜
 * @author zhuqijia
 */

import Haotianjing from '@baidu/map-car-haotianjing';

const keyPart1 = 'eyJhcHBfa2V5IjoiNTA0OCIsImFwcF92aWV3IjoicHJvbW90ZSIsImZvcm1fZGVzYyI6IiIsInNlbmRfaW50ZXJ2YWwiOjUw';
const keyPart2 = 'LCJzZW5kX21ldGhvZCI6MywiYnJvd3Nlcl91cmwiOiJodHRwczovL3NvZmlyZS5iYWlkdS5jb20vZGF0YS91YS9hYi5qc29uIn0=';

// 启用昊天镜
Haotianjing.enableHaoTianJing({
    cuid: window.yymap.nativeAppAdapter.query.cuid || window.yymap.nativeAppAdapter.phoneinfo.cuid || '',
    // 注意：安全组提供的活动渠道号（appkey），为非必传参数，默认使用车主业务的id
    aid: 5048,
    // 注意：安全组提供的jssdk data-app参数，为非必传参数，默认使用车主业务
    jssdkKey: keyPart1 + keyPart2 // 太长，分成两部分
});

// xaf为昊天镜的参数
// 初始化xaf，当window.xaf不存在时，赋一个初始值，避免xaf.getData.Token取不到值时报错
const initXaf = {
    getData: () => {
        return {
            Token: null,
            view: null
        };
    }
};

window.xaf = window.xaf || initXaf; // 兼容昊天镜初始化失败后xaf不存在的异常问题
